(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[893],{

/***/ "it/u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Transfer", function() { return Transfer; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Transfer = function Transfer(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "m26.52 13.5-2.67-4.97A2.17 2.17 0 0 0 21.9 7.3H5.16C3.97 7.3 3 8.27 3 9.46v8.77c0 1.13.87 2.04 1.97 2.15a2.97 2.97 0 0 0 5.79.02h8.48a2.99 2.99 0 0 0 2.89 2.3c1.4 0 2.6-.99 2.9-2.32A2.16 2.16 0 0 0 27 18.24v-2.8c0-.66-.17-1.33-.48-1.93Zm-4.45-4.07 2.27 4.23h-4.29c-.44-.97-.4-2.12.16-3.06l.78-1.31h.92c.06 0 .12.04.17.14h-.01Zm2.78 8.96h-.04a2.95 2.95 0 0 0-2.45-1.64l-.86-1.1h3.52v2.58c0 .1-.07.16-.16.16h-.01ZM15.6 9.3l-1.4 2.5a1.4 1.4 0 0 1-1.21.72H10.4l1.56-3.22h3.64Zm-10.42 0h4.56l-1.56 3.2H5.02V9.45c0-.1.07-.16.16-.16Zm2.7 11.4a.98.98 0 1 1 0-1.96.98.98 0 0 1 0 1.96Zm11.6-2.3h-8.94a2.98 2.98 0 0 0-2.66-1.67c-1.17 0-2.17.68-2.66 1.67h-.04a.18.18 0 0 1-.17-.17v-3.71h7.97a3.4 3.4 0 0 0 2.96-1.74l1.94-3.5h.78l-.17.3a5.35 5.35 0 0 0 .39 5.98l1.43 1.81a3 3 0 0 0-.83 1.01v.02Zm2.66 2.3a.98.98 0 1 1 0-1.96.98.98 0 0 1 0 1.96Z"
  }));
};

/***/ })

}]);